import { XmlSchemaObject } from '../XmlSchemaObject';

export abstract class XmlSchemaAnnotationItem extends XmlSchemaObject {}
